import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import PublicLayout from "./components/PublicLayout";
import Home from "./pages/Home";
import OperadorDigital from "./pages/OperadorDigital";
import Ecosistema from "./pages/Ecosistema";
import LegalPage from "./pages/LegalPage";
import Contacto from "./pages/Contacto";
import Login from "./pages/Login";
import Intranet from "./pages/Intranet";
import MatrizLayout from "./pages/matriz/MatrizLayout";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#F7F8FA] flex items-center justify-center"><span className="font-mono-tech text-xs text-[#5698C7] tracking-widest">VERIFICANDO ACCESO...</span></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "editor") return <Navigate to="/intranet" replace />;
  return children;
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/operador-digital" element={<OperadorDigital />} />
              <Route path="/ecosistema" element={<Ecosistema />} />
              <Route path="/legal" element={<LegalPage />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/contacto" element={<Contacto />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/intranet" element={<Protected><Intranet /></Protected>} />
            <Route path="/matriz/*" element={<Protected adminOnly><MatrizLayout /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" toastOptions={{ style: { background: "#ffffff", border: "1px solid #E2E8F0", color: "#0B1220", boxShadow: "0 4px 14px rgba(15,23,42,0.1)" } }} />
      </AuthProvider>
    </LangProvider>
  );
}
